/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_ContactInputs */

const en_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const es_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacto`)
};

const de_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const zh_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系`)
};

const ar_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تواصل معنا`)
};

const fr_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const vi_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ`)
};

const sw_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wasiliana`)
};

const th_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อ`)
};

const bs_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ja_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const ko_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의`)
};

const pt_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contato`)
};

const it_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contatti`)
};

const sv_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const nl_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact`)
};

const da_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const nb_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const fi_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteystiedot`)
};

const pl_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const ru_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Контакты`)
};

const tr_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İletişim`)
};

const hi_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`संपर्क`)
};

const id_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const ms_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi`)
};

const cs_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const el_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επικοινωνία`)
};

const he_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`צרו קשר`)
};

const af_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontak`)
};

const hu_nav_contact = /** @type {(inputs: Nav_ContactInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolat`)
};

/**
* | output |
* | --- |
* | "Contact" |
*
* @param {Nav_ContactInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_contact = /** @type {((inputs?: Nav_ContactInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_ContactInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_contact(inputs)
	if (locale === "de") return de_nav_contact(inputs)
	if (locale === "zh") return zh_nav_contact(inputs)
	if (locale === "ar") return ar_nav_contact(inputs)
	if (locale === "fr") return fr_nav_contact(inputs)
	if (locale === "vi") return vi_nav_contact(inputs)
	if (locale === "sw") return sw_nav_contact(inputs)
	if (locale === "th") return th_nav_contact(inputs)
	if (locale === "bs") return bs_nav_contact(inputs)
	if (locale === "ja") return ja_nav_contact(inputs)
	if (locale === "ko") return ko_nav_contact(inputs)
	if (locale === "pt") return pt_nav_contact(inputs)
	if (locale === "it") return it_nav_contact(inputs)
	if (locale === "sv") return sv_nav_contact(inputs)
	if (locale === "nl") return nl_nav_contact(inputs)
	if (locale === "da") return da_nav_contact(inputs)
	if (locale === "nb") return nb_nav_contact(inputs)
	if (locale === "fi") return fi_nav_contact(inputs)
	if (locale === "pl") return pl_nav_contact(inputs)
	if (locale === "ru") return ru_nav_contact(inputs)
	if (locale === "tr") return tr_nav_contact(inputs)
	if (locale === "hi") return hi_nav_contact(inputs)
	if (locale === "id") return id_nav_contact(inputs)
	if (locale === "ms") return ms_nav_contact(inputs)
	if (locale === "cs") return cs_nav_contact(inputs)
	if (locale === "el") return el_nav_contact(inputs)
	if (locale === "he") return he_nav_contact(inputs)
	if (locale === "af") return af_nav_contact(inputs)
	if (locale === "hu") return hu_nav_contact(inputs)
	return en_nav_contact(inputs)
});